<!--
 * @Description: 登录（PC3.0）
 * @Author:  wang.y
-->
<template>
  <Modal v-model="modelIndex" width="500" class="login-model" @on-cancel="close" @on-visible-change="resetForms" :footer-hide="true">
    <div class="container-wrapper">
      <div class="container-top">
        <div class="container-title">完善资料后即可查看报告</div>
        <Form ref="user-info-form" :model="userForm" :rules="ruleValidate">
          <FormItem prop="name" label="姓名">
            <Input type="text" v-model="userForm.name" placeholder="请填写姓名"></Input>
          </FormItem>
          <FormItem prop="compName" label="公司或机构名称">
            <AutoComplete v-model="entityKeyword" @on-search="handleSearchEntity" @on-select="handleSelectEntity" @on-change="handleChangeEntity" placeholder="请填写公司或机构名称">
              <Option v-for="item in entityList" :value="item.id" :key="item.id">
                <div class="title">
                  {{item.shortName}}
                </div>
                <div class="desc">
                  {{item.description}}
                </div>
              </Option>
            </AutoComplete>
            <Tag v-if="userForm.entityId" closable @on-close="handleClose" color="blue">{{userForm.compName}}</Tag>
            <div style="width: 0; height: 0; overflow: hidden;">
              <Input v-model="userForm.compName" />
            </div>
          </FormItem>
          <FormItem prop="title" label="职务/职位">
            <Input type="text" v-model="userForm.title" placeholder="请填写职务/职位"></Input>
          </FormItem>
          <FormItem prop="email" label="电子邮箱">
            <Input type="text" v-model="userForm.email" placeholder="请填写电子邮箱"></Input>
          </FormItem>
        </Form>
      </div>
      <div class="footer-wrap">
        <div :class="{'flash': isFlash}">
          <Checkbox v-model="isAgree" @on-change="isAgree ? isFlash = false : ''"></Checkbox>
          勾选即代表阅读并同意<span style="color: #245CDA;cursor: pointer;" @click="goToPravicy">《隐私声明》</span>
        </div>
        <Button @click="handleClickSure" class="update-btn">保存并打开报告</Button>
      </div>
    </div>
  </Modal>
</template>

<script>
import { updateAccount, AsearchComp } from '@/service'
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState({
      static_img_url: (state) => state.static_img_url,
      index_path: (state) => state.index2_path,
      index2_path: (state) => state.index2_path,
      req_url: (state) => state.req_url,
      user_key: (state) => state.user_key,
      user: (state) => state.user,
    }),
  },
  data() {
    return {
      isAgree: true,
      isFlash: false,
      entityList: [],
      entityKeyword: '',
      modelIndex: false,
      userForm: {
        name: '',
        compName: '',
        entityId: 0,
        title: '',
        email: '',
      },
      ruleValidate: {
        name: [{ required: true, message: '请填写姓名', trigger: 'blur' }],
        compName: [{ required: true, message: '请填写企业名称', trigger: 'change' }],
        title: [{ required: true, message: '请填写职务/职位', trigger: 'blur' }],
        email: [
          { required: true, message: '请填写邮箱', trigger: 'blur' },
          { type: 'email', message: '请填写正确的邮箱', trigger: 'blur' },
        ],
      },
      reportId: '',
      reportUid: '',
    }
  },
  methods: {
    close() {
      this.modelIndex = false
    },
    resetForms(value) {
      if (value) {
        let user = { ...this.user }
        this.userForm = {
          name: user.name || '',
          compName: user.compName || '',
          entityId: user.entityId || 0,
          title: user.title || '',
          email: user.email || '',
        }
        this.entityKeyword = this.userForm.entityId ? '' : this.userForm.compName
      } else {
        this.smtCb = ''
      }
    },
    async handleSearchEntity() {
      let res = await AsearchComp(
        {
          boardId: 1,
          keyword: this.entityKeyword,
          page: 1,
          size: 10,
        },
        (error) => {
          this.$Message.error('请求错误！')
        }
      )
      if (res.code == 0) {
        this.entityList = [...res.data]
      } else {
        this.$Message.error(res.msg)
      }
    },
    handleSelectEntity(value) {
      let item = this.entityList.find((a) => a.id === value)
      this.$nextTick(() => {
        this.entityKeyword = ''
        this.userForm.entityId = item.id
        this.userForm.compName = item.shortName
      })
    },
    handleChangeEntity() {
      if (!this.userForm.entityId) {
        this.userForm.compName = this.entityKeyword
      }
    },
    handleClose() {
      this.userForm.entityId = ''
      this.userForm.compName = this.entityKeyword
    },
    handleClickSure() {
      if (this.isAgree == false) {
        this.isFlash = true
        return
      }
      this.$refs['user-info-form'].validate(async (valid) => {
        if (valid) {
          let params = {
            user_key: this.user_key,
            agree_status: this.isAgree ? 1 : 0,
            uid: this.reportUid,
            data: {
              name: this.userForm.name,
              comp_name: this.userForm.compName,
              entity_id: this.userForm.entityId,
              title: this.userForm.title,
              email: this.userForm.email,
            },
          }
          let res = await updateAccount(params, (error) => {
            this.$Message.error('请求错误！')
          })
          if (res.status == 'success') {
            let user_info = { ...this.user }
            user_info.name = this.userForm.name
            user_info.title = this.userForm.title
            user_info.compName = this.userForm.compName
            user_info.entityId = this.userForm.entityId
            user_info.email = this.userForm.email
            this.$store.commit('updateUser', user_info)
            this.$Message.success('保存成功！')
            this.modelIndex = false
            this.$emit('success')
          } else {
            this.$Message.error(res.message)
          }
        }
      })
    },
    goToPravicy() {
      const href = this.index_path + '/privacy'
      window.open(href, '_blank')
    },
  },
  mounted() {},
}
</script>

<style lang="stylus" scoped>
.container-wrapper
  min-height 420px
  height auto
  position relative
  padding-bottom 62px
  .container-title
    font-size 18px
    color #3D3D3D
    line-height 25px
  >>> .ivu-form
    margin-top 20px
    .ivu-form-item-label
      padding 0 0 4px 0
      color #606266
    .ivu-form-item
      margin-bottom 0
      min-height 40px
      &+.ivu-form-item
        margin-top 16px
      .ivu-form-item-content
        line-height 1
        .ivu-form-item-error-tip
          padding-top 4px
          color #FC3B3B
          position relative
          top auto
          left auto
        .ivu-input-suffix
          width 40px
          i
            line-height 40px
            cursor pointer
            color #666
        .ivu-input, .ivu-select-selection
          height 40px
          font-size 14px
          color #333333
          line-height 20px
          border-color #DCDFE6
          box-shadow none
          outline none
        .ivu-select-placeholder, .ivu-select-selected-value
          height 40px
          line-height 40px
        .ivu-select-item-selected, .ivu-select-item-selected:hover
          color #FA5A00
    .ivu-tag-blue
      .ivu-icon-ios-close
        color #1890ff !important
    .ivu-select-dropdown-list
      max-height 200px
      .desc
        margin-top 4px
        text-align left
        white-space normal
        line-height 18px
    .container-bottom
      position initial
      bottom auto
      left auto
      right auto
.footer-wrap
  display flex
  justify-content space-between
  align-items center
  position absolute
  bottom 10px
  left 0
  width 100%
  >>> .ivu-checkbox-wrapper
    margin-right 2px
    .ivu-checkbox-checked
      .ivu-checkbox-inner
        border-color #FA5A00
        background-color #FA5A00
    .ivu-checkbox-disabled.ivu-checkbox-checked
      .ivu-checkbox-inner:after
        border-color #fff
    .checkbox-label
      font-size 12px
      font-weight 400
      color #3D3D3D
      line-height 14px
      margin-left 6px
      padding-bottom 1px
      a
        cursor pointer
        color #1572E7
        &:hover
          color #2d8cf0
  .flash
    color #fc3b3b
    animation flash 0.1s linear 2
  .update-btn
    background-color #FA5A00
    border-color #FA5A00
    color #FFF
    box-shadow none
    &:hover
      background-color #FF4800
      border-color #FF4800
@keyframes flash
  from
    transform translateY(-3px)
  to
    transform translateY(3px)
</style>
